import { Component, OnInit, AfterViewInit, OnChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FarmDTOGeneric } from 'src/app/shared/dtos/FarmDTOGeneric';
import { FarmService } from 'src/app/content/farm/farm.service';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import * as L from 'leaflet';
import 'leaflet-draw';
import { MapService } from 'src/app/content/farm/map.service';
import { MapStyleService } from 'src/app/content/farm/map-style.service';


@Component({
  selector: 'app-edit-farm',
  templateUrl: './edit-farm.component.html',
  styleUrls: ['./edit-farm.component.css']
})
export class EditFarmComponent implements OnInit, AfterViewInit, OnChanges {

  farm: FarmDTOGeneric;
  formGeometry: FormGroup;
  private MAP_ID = 'map4';
  private map: L.map;
  drawnItems: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private farmService: FarmService,
    private formBuilder: FormBuilder,
    private mapService: MapService,
    private mapStyleService: MapStyleService) { }

  ngOnInit(): void {
    this.formGeometry = this.formBuilder.group(
      {
        geometry : new FormControl(''),
      });

  }


  ngAfterViewInit(): void {
    //CREATE MAP
    this.map = L.map(this.MAP_ID, this.mapService.getDefaultCreateFarmMapOptions());
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution:
        '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(this.map);

    //crear funcionalidades de leaflet.draw
    this.drawnItems = new L.FeatureGroup();
    this.map.addLayer(this.drawnItems);

    L.control.layers(this.mapService.getBaseLayers(), 
      this.mapService.getOverLayers(), { collapsed: false }).addTo(this.map);

    //modificar los textos del tooltip y toolbar
    this.mapStyleService.getDrawCustomOptions();

    //Asignar propiedades al toolbar
    const drawControl = this.mapStyleService.getDrawControlFarms(this.drawnItems, false);
    this.map.addControl(drawControl);
    this.getFarmById();
    const farm = this.farm;
    console.log(farm);
  }

  getFarmById(){
    const id = +this.route.snapshot.paramMap.get('id');
    this.farmService.getFarmById(id)
    .subscribe(
      res => {
        this.farm = res;
        if (this.farm !== undefined){
          const layer = L.geoJson(this.farm.geometry).addTo(this.map);
          this.drawnItems.addLayer(layer);
        } else {
          this.router.navigate(['/']);
        }
    },
    error => {
      console.log("error");
    },
    () => {
      // 'onCompleted' callback.
      // No errors, route to new page here
    })

  }

  ngOnChanges(): void {

    if (this.farm !== undefined){
      const layer = L.geoJson(this.farm.geometry).addTo(this.map);
  
      this.drawnItems.addLayer();
  
    } 
  }

  onSubmit(){

  }

}
